import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

interface Props {
    onButtonClick: () => void,
    buttonText: string,
    message: string,
    title: string
}

export default function NotifyDialog({
    onButtonClick,
    buttonText,
    title,
    message
} : Props) {
  return (
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        className="p-4 w-[400px] rounded-xl overflow-hidden shadow-2xl"
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {message}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex justify-center">
          <Button onClick={onButtonClick}>{buttonText}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
